"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getToggleSlots = exports.default = exports.Toggle = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _toggleClasses = _interopRequireWildcard(require("./toggleClasses"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
}
var getToggleSlots = function(ownerState) {
    var fullWidth = ownerState.fullWidth, active = ownerState.active, disabled = ownerState.disabled;
    return {
        root: [
            'root',
            fullWidth && 'fullWidth',
            disabled && 'disabled'
        ],
        indicator: [
            'indicator',
            active && 'indicatorActive'
        ],
        text: [
            'text'
        ],
        checkbox: [
            'checkbox'
        ]
    };
};
exports.getToggleSlots = getToggleSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getToggleSlots(ownerState);
    var composedClasses = (0, _base.unstable_composeClasses)(slots, _toggleClasses.getToggleUtilityClass, classes);
    return composedClasses;
};
var ToggleRoot = (0, _material.styled)('label', {
    name: 'MuiOriToggle',
    slot: 'Root',
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.root,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread_props(_object_spread({
        display: 'inline-grid',
        gridTemplateColumns: '1fr 1fr',
        justifyItems: 'center',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        paddingLeft: 15,
        paddingRight: 15,
        borderRadius: 30,
        backgroundColor: theme.palette.grey[100],
        columnGap: theme.spacing(6),
        border: "3px solid ".concat(theme.palette.grey[100]),
        cursor: 'pointer'
    }, ownerState.disabled && {
        cursor: 'inherit'
    }, ownerState.fullWidth && {
        width: '100%'
    }), _define_property({}, "&.".concat(_toggleClasses.default.disabled, " .").concat(_toggleClasses.default.text), {
        color: theme.palette.grey[400]
    }));
});
var Indicator = (0, _material.styled)('div', {
    name: 'MuiOriToggle',
    slot: 'Indicator',
    skipSx: true,
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.indicator,
            ownerState.active && styles.indicatorActive
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread_props(_object_spread({
        position: 'absolute',
        width: 'calc(50% - 2px)',
        height: 'calc(100% - 4px)',
        top: 2,
        left: 2,
        borderRadius: 30,
        zIndex: 1,
        backgroundColor: theme.palette.common.white,
        transition: theme.transitions.create('transform')
    }, ownerState.active && {
        transform: 'translate(100%)'
    }), _define_property({}, "&.".concat(_toggleClasses.default.disabled), {
        backgroundColor: theme.palette.action.disabledBackground
    }));
});
var Text = (0, _material.styled)('span', {
    name: 'MuiOriToggle',
    slot: 'Text',
    skipSx: true,
    overridesResolver: function(param, styles) {
        var ownerState = param.ownerState;
        return [
            styles.text
        ];
    }
})(function(param) {
    var theme = param.theme, ownerState = param.ownerState;
    return _object_spread({
        display: 'inline-block',
        paddingTop: '0.9rem',
        paddingBottom: '0.9rem',
        height: '3.9rem',
        zIndex: 2,
        margin: 0,
        fontSize: theme.typography.body1.fontSize,
        lineHeight: 1.5,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        transition: theme.transitions.create('color'),
        userSelect: 'none',
        color: theme.palette.text.secondary,
        textAlign: 'center',
        boxSizing: 'border-box',
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }, ownerState.isIcon && {
        paddingTop: '0.7rem',
        paddingBottom: '0.7rem'
    }, ownerState.active && {
        color: theme.palette.text.primary
    });
});
var Checkbox = (0, _material.styled)('input', {
    name: 'MuiOriToggle',
    slot: 'Checkbox',
    skipSx: true,
    overridesResolver: function(_, styles) {
        return [
            styles.checkbox
        ];
    }
})({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1
});
var Toggle = exports.Toggle = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriToggle'
    });
    var id = props.id, firstIcon = props.firstIcon, secondIcon = props.secondIcon, firstText = props.firstText, secondText = props.secondText, checked = props.checked, onChange = props.onChange, defaultChecked = props.defaultChecked, fullWidth = props.fullWidth, className = props.className, disabled = props.disabled, component = props.component, rest = _object_without_properties(props, [
        "id",
        "firstIcon",
        "secondIcon",
        "firstText",
        "secondText",
        "checked",
        "onChange",
        "defaultChecked",
        "fullWidth",
        "className",
        "disabled",
        "component"
    ]);
    var _ref = (0, _react.useRef)(checked != null), controlled = _ref.current;
    var _ref1 = _sliced_to_array((0, _react.useState)(Boolean(defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : checked)), 2), value = _ref1[0], setValue = _ref1[1];
    var isFirstIcon = (0, _react.useMemo)(function() {
        return typeof firstIcon !== 'undefined';
    }, [
        firstIcon
    ]);
    var isSecondIcon = (0, _react.useMemo)(function() {
        return typeof secondIcon !== 'undefined';
    }, [
        secondIcon
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        disabled: disabled,
        active: value,
        fullWidth: fullWidth,
        isIcon: false
    });
    var classes = useUtilityClasses(ownerState);
    (0, _react.useEffect)(function() {
        if (typeof checked === 'boolean') {
            setValue(checked);
        }
    }, [
        checked
    ]);
    var handleChange = (0, _react.useCallback)(function(event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        if (!controlled) {
            setValue(event.currentTarget.checked);
        }
    }, [
        onChange,
        controlled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ToggleRoot, _object_spread_props(_object_spread({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        htmlFor: id
    }, rest), {
        as: component,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Indicator, {
                ownerState: ownerState,
                className: classes.indicator
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Text, {
                ownerState: _object_spread_props(_object_spread({}, ownerState), {
                    active: !value,
                    isIcon: isFirstIcon
                }),
                className: (0, _clsx.default)(classes.text, isFirstIcon && _toggleClasses.default.icon, !value && _toggleClasses.default.textActive),
                "data-text": firstText,
                children: isFirstIcon ? firstIcon : firstText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Text, {
                ownerState: _object_spread_props(_object_spread({}, ownerState), {
                    isIcon: isSecondIcon
                }),
                className: (0, _clsx.default)(classes.text, isSecondIcon && _toggleClasses.default.icon, value && _toggleClasses.default.textActive),
                "data-text": secondText,
                children: isSecondIcon ? secondIcon : secondText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Checkbox, {
                id: id,
                ownerState: ownerState,
                className: classes.checkbox,
                type: "checkbox",
                checked: value,
                disabled: disabled,
                onChange: handleChange
            })
        ]
    }));
});
var _default = exports.default = Toggle; //# sourceMappingURL=Toggle.js.map
